import * as angular from 'angular';
import * as _ from 'lodash';

import { AggregationMode, ComponentDefinition, DropObject, ISortConfiguration, IValueViewModel, KeyValuePair, ObjectType } from '../../../models';
import { PivotTableSeriesDefinition } from '../PivotTableSeriesDefinition';
import { ISeriesSelectorService } from '../../../services/data';
import { aggregationModes, blackTextColor } from '../../../common';

interface RowTuple {
    model: PivotTableSeriesDefinition;
    viewModel: IValueViewModel;
}

class PivotTableSeriesDefinitionController implements angular.IComponentController {
    aggregationModes: KeyValuePair<AggregationMode, string>[];
    isBindable: boolean;
    series: PivotTableSeriesDefinition[];
    seriesTuples: RowTuple[];
    sortConfig: ISortConfiguration<RowTuple> = {
        animation: 150,
        onSort: evt => this.sort(evt),
        handle: '.drag-handle'
    };
    viewModels: IValueViewModel[];

    static $inject = ['seriesSelectorService'];
    constructor(private _seriesSelectorService: ISeriesSelectorService) {
    }

    $onInit() {
        const mapped = aggregationModes.map(d => d);
        mapped.splice(0, 1);
        this.aggregationModes = mapped;
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (this.series && this.viewModels) {
            this.seriesTuples = this.series
                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                .map(s => {
                    return {
                        model: s,
                        viewModel: _.find(this.viewModels, vm => vm.guid === s.guid)
                    };
                });
        }
    }

    private sort(evt: { models: RowTuple[] }) {
        evt.models.forEach((s, i) => s.model.sortOrder = i);
        this.series = evt.models.map(s => s.model).sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1);
    }

    drop(data: DropObject) {
        const guid = data.itemId;
        const vm = _.find(this.viewModels, vm => vm.guid === guid);
        const series: PivotTableSeriesDefinition = {
            guid: vm.guid,
            aggregationMode: AggregationMode.Average,
            color: blackTextColor,
            decimals: 2,
            hasAlarms: false,
            isBoundToGroup: !!this.isBindable,
            sortOrder: 0,
            value: '',
            originalGuid: ''
        };
        if (this.series.length) {
            series.sortOrder = _.maxBy(this.series, s => s.sortOrder).sortOrder + 1;
        }
        series.value = this._seriesSelectorService.getAvailableValueType(vm, this.series);
        this.series.push(series);
        this.seriesTuples.push({
            model: series,
            viewModel: vm
        });
    }

    dropExisting(data: DropObject, tuple: RowTuple) {
        tuple.model.guid = data.itemId;
        const vm = _.find(this.viewModels, d => d.guid === tuple.model.guid);
        if (this._seriesSelectorService.getValues(vm).map(d => d.key).indexOf(tuple.model.value) < 0) {
            tuple.model.value = this._seriesSelectorService.getAvailableValueType(vm, this.series);
        }
        if (vm.objectType === ObjectType.Tag) {
            tuple.model.isBoundToGroup = false;
        } 
        tuple.viewModel = vm;
    }

    remove(tuple: RowTuple, $index: number) {
        this.seriesTuples.splice($index, 1);
        this.series.splice($index, 1);
    }
}

export const wtPivotTableSeriesDefinition: ComponentDefinition = {
    componentId: 'wtPivotTableSeriesDefinition',
    controller: PivotTableSeriesDefinitionController,
    template: require('./pivotTableSeriesDefinition.component.html'),
    controllerAs: 'vm',
    bindings: {
        isBindable: '<?',
        series: '<',
        viewModels: '<'
    }
};
